import script from "./JustView.vue?vue&type=script&setup=true&lang=js"
export * from "./JustView.vue?vue&type=script&setup=true&lang=js"

import "./JustView.vue?vue&type=style&index=0&id=9a8c13d4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a8c13d4"]])

export default __exports__